import { render } from "./ListeJournalConnexionPage.vue?vue&type=template&id=23c250fe&ts=true"
import script from "./ListeJournalConnexionPage.vue?vue&type=script&lang=ts"
export * from "./ListeJournalConnexionPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__